const e = {
  page404: {
    title: "Zrejme ste sa stratili",
    message: "Stratili ste sa?",
    action_btn: "Späť na úvod"
  },
  address: {
    title: "Address",
    type: {
      personal: "Súkromná osoba",
      company: "Firma"
    },
    organisation: {
      label: "Názov firmy"
    },
    name: {
      first_name: "Krstné meno",
      last_name: "Priezvisko",
      label: "Kontaktná osoba"
    },
    contact_person: {
      first_name: "Krstné meno",
      last_name: "Priezvisko",
      label: "Kontaktná osoba"
    },
    street: {
      label: "Ulica a číslo",
      address1: "Address 1",
      address2: "Address 2"
    },
    city: {
      label: "Mesto"
    },
    postal_code: {
      label: "PSČ"
    },
    country_code: {
      label: "Krajina"
    },
    company_data: {
      title: "Firemné údaje"
    },
    company_id: {
      label: "IČO"
    },
    tax_id: {
      label: "DIČ"
    },
    vat_id: {
      label: "IČ DPH"
    }
  },
  empty_state: {
    title: "Nič sme nenašli..."
  },
  profile: {
    emails: {
      label: "Email (môžete zadať viac emailov)"
    },
    email: {
      label: "Email"
    },
    phone: {
      label: "Telefón",
      short: "Phone"
    }
  },
  validation: {
    country_required: "Vyplňte krajinu",
    company_id: {
      not_valid: "Neplatné IČO"
    },
    tax_id: {
      not_valid: "Neplatné DIČ"
    },
    vat_id: {
      not_valid: "Neplatné IČ DPH"
    }
  },
  general: {
    back: "Naspäť",
    cancel: "Zrušiť",
    close: "Zavrieť",
    remove: "Odstrániť",
    optional: "nepovinné",
    period: {
      months: "{period, plural, one {# mesiac} few {# mesiace} other {# mesiacov}}",
      years: "{period, plural, one {# rok} few {# roky} other {# rokov}}",
      explicit: "Obdobie",
      short: {
        months: "{period} mes.",
        years: "{period, plural, one {# rok} few {# roky} other {# rokov}}"
      },
      next: {
        months: "{period, plural, one {ďalší mesiac} few {ďalšie # mesiace} other {ďalších # mesiacov}}",
        years: "{period, plural, one {ďalší rok} few {ďalšie # roky} other {ďalších # rokov}}",
        short: {
          months: "{period, plural, one {# ďalší mes.} few {ďalšie # mes.} other {ďalších # mes.}}",
          years: "{period, plural, one {# ďalší rok} few {ďalšie # roky} other {ďalších # rokov}}"
        }
      },
      per: {
        months: "{ period, plural, one {mesačne} other {na #  mesiacov} }",
        years: "{ period, plural, one {ročne} other {na #  rokov} }",
        short: {
          months: "{ period, plural, one {/mes} other {/#mes} }",
          years: "{ period, plural, one {ročne} few {na # roky} other {na # rokov} }"
        }
      }
    },
    or: "alebo",
    recommended: "odporúčame",
    settings: "Nastavenia",
    edit: "Upraviť",
    save: "Uložiť",
    save_changes: "Uložiť",
    reset_form: "Obnoviť formulár",
    not_available: "Nedostupné",
    unknown_error: "Neznáma chyba",
    unknown_error_id: "Neznáma chyba ({id})",
    something_went_wrong: "Ospravedlňujeme sa za neočakávaný výsledok. Niečo sa pokazilo.",
    link: "odkaz",
    buy: "Kúpiť"
  },
  capslock_hint: {
    line1: "Caps Lock",
    line2: "je zapnutý"
  },
  ws_array_input: {
    some_filtered: "Tento reťazec nie je možné spracovať."
  },
  ws_places_input: {
    no_results: "Hľadané miesto nebolo nájdené, skúste menej špecifickú adresu"
  },
  ws_uploader: {
    validation: {
      file_type: "Nesprávny typ súboru.",
      file_size: "Veľkosť súboru prekročila limit ({limit})"
    },
    status: {
      label: "Stav",
      value: {
        uploaded: "nahraté",
        uploading: "nahrávam",
        failed: "zlyhané",
        idle: "idle"
      }
    },
    action: {
      title: "Nahrajte faktúry",
      text1: "Presuňte súbor alebo",
      link: "vyberte",
      text2: ".",
      abort_tooltip: "Zrušiť nahrávanie"
    },
    remove_btn: "Odstrániť"
  },
  ws_table: {
    filter: {
      fulltext_title: "Fulltext vyhľadávanie",
      data_title: "Vyhľadávanie",
      clear_filters: "Vymazať všetky filtre",
      from: "Od",
      to: "Do"
    },
    label: {
      bulk_actions: "Hromadné akcie",
      cancel_selection: "Zrušiť výber",
      item_selected: "vybratých položiek",
      selected: "Vybratých",
      filterby: "Triediť podľa",
      records_per_page: "Záznamy na stránku:",
      select_all: "Vybrať všetko"
    }
  },
  ws_password_strength: {
    rule1: "Minimálne 8 znakov",
    rule2: "Minimálne 1 veľké a 1 malé písmeno",
    rule3: "Minimálne 1 číslo",
    rule4: "Minimálne 1 špeciálny znak"
  },
  ws_password_confirmation_input: {
    passwords_do_not_match: "Heslá sa nezhodujú!"
  },
  ws_two_factor_authentication_input: {
    on_cooldown_one: "Kód môžete znova odoslať o {{count}} sekundu.",
    on_cooldown_few: "Kód môžete znova odoslať o {{count}} sekundy.",
    on_cooldown_other: "Kód môžete znova odoslať o {{count}} sekúnd.",
    resend_code: "Resend code",
    code_being_sent: "Sending 2FA code...",
    code_sent_successfully: "2FA code sent successfully",
    error_sending_code: "Error sending 2FA code",
    invalid_code_pasted: "Bol zadaný neplatný kód pre dvojfaktorovú autentifikáciu. Prosím zadajte správny kód."
  },
  generate_random: "Generuj náhodné",
  copy: {
    copy: "Skopírovať",
    copied: "Skopírované",
    saved_in_clipboard: "Skopírované"
  },
  out_modal: {
    title: "Váš prehliadač nie je aktualizovaný.",
    text: "Prosím, aktualizujte prehliadač alebo použite iný.",
    delimiter_text: "Môžeme pomôcť"
  },
  buttons: {
    ok_thanks: "Ok, Thanks"
  },
  payment_cards: {
    ending_with: "Ending with",
    active: "Active"
  },
  ws_sub_items_price_summary: {
    current_price: "Cena za službu (aktuálne obdobie)",
    due_now: "Splatné ihneď",
    next_period_subtraction_warning: "* Suma bude odpočítaná v nasledujúcom fakturačnom období.",
    next_price: "Cena za službu (ďalšie obdobie)"
  },
  dialog_footer: {
    cannot_submit_empty_form: "It is not possible to submit an empty form."
  },
  price_badge: {
    including_vat: "(s DPH)",
    excluding_vat: "(bez DPH)"
  },
  login_pages: {
    footer: {
      help: "Pomoc",
      terms: "Podmienky",
      privacy: "Súkromie"
    },
    help: {
      title: "Potrebujete poradiť?",
      text: "Pozrite sa do našej  <a href='{kb_url}' target='_blank'>bázy znalostí</a>. Ak nenájdete odpoveď na vašu otázku, neváhajte kontaktovať našu  <a href='{support_url}' target='_blank'>podporu</a>."
    }
  },
  message_service: {
    error: {
      axios: {
        title: "Network Error",
        text: "Unable to connect"
      },
      unexpected: {
        title: "Error",
        text: "Unexpected error"
      }
    }
  }
}, o = {
  wsk: e
};
export {
  o as default,
  e as wsk
};
//# sourceMappingURL=wsk.sk-SK-40850c14.js.map
